import React, { Component } from "react";
import Button from "../../../Components/common/Button";
import SearchField from "../../../Components/common/SearchField";
import { connect } from "react-redux";
import isEqual from "react-fast-compare";
import { checkPrivileges } from "../../../Helpers";
import ConfirmDialoag from "../../../Components/common/ConfirmDialoag";
import Style from "style-it";
import Scrollbar from "react-scrollbars-custom";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../Loader";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ShareIcon from "@mui/icons-material/Share";
import { ReactComponent as CityIcon } from "../../../assets/garages/city.svg";
import { ReactComponent as GarageIcon } from "../../../assets/garages/Garage.svg";
import { ReactComponent as EnterIcon } from "../../../assets/garages/enter.svg";
import { IconButton, InputAdornment, Chip, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import withTranslationWrapper from "../../../HOC/withTranslation";
import { notifySuccess, notifyError } from "../../../Utils/CustomNotifcations";
import {
  filterGaragesForMobility,
  getGarageStatus,
  getGarageStatusChipStyle,
  isMobilityGarageUser,
} from "../../../Pages/Garage/garageStatusUtils";

const buildGarageMapsUrl = (item = {}) => {
  const lat = Number(item.latitude);
  const lng = Number(item.longitude);
  if (Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0)) {
    return `https://www.google.com/maps?q=${lat},${lng}`;
  }
  const address = String(item.address || item.name || "").trim();
  if (address) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      address,
    )}`;
  }
  return "";
};
class Garage extends Component {
  constructor(props) {
    super(props);
    this.state = { searchRecently: "" };
  }

  search(e, check, name) {
    this.props.searchItems(e.target.value, check, name);
  }

  render() {
    const { deleteItem } = this.props;
    const garageItems = this.props.itemPagination?.items || [];
    const visibleGarages = isMobilityGarageUser(this.props.logInUser?.userType)
      ? filterGaragesForMobility(garageItems)
      : garageItems;

    const commands1 = visibleGarages.map((g) => (
      <ListRow
        key={g.id}
        item={g}
        deleteItem={deleteItem}
        editGarageForm={this.props.editGarageForm}
        onOpenMap={this.props.onOpenMap}
        setGarageForm={this.props.setGarageForm}
        onClick={this.props.selectSingleGarage}
        showSingleGarage={this.props.showSingleGarage}
        logInUser={this.props.logInUser}
      />
    ));

    return (
      <Style>
        {`
					.material-icons {vertical-align: middle; color: inherit}
          .fms-sidebar .garage-sidebar-list .list-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            padding-right: 6px;
          }
          .fms-sidebar .garage-sidebar-list .list-row .checkbox {
            position: static;
            flex: 1 1 auto;
            min-width: 0;
            margin-right: 0;
            max-width: calc(100% - 78px);
          }
          .fms-sidebar .garage-sidebar-list .list-row .garage-row-content {
            display: flex;
            align-items: center;
            gap: 6px;
            min-width: 0;
            width: 100%;
          }
          .fms-sidebar .garage-sidebar-list .list-row .garage-unit-name {
            max-width: none !important;
            min-width: 0 !important;
            width: auto !important;
            flex: 0 1 auto;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block !important;
            margin-left: 5px;
            line-height: 20px;
            vertical-align: middle;
          }
          .fms-sidebar .garage-sidebar-list .list-row .garage-status-chip {
            flex: 0 0 auto;
            margin-left: 0;
          }
          .fms-sidebar .garage-sidebar-list .list-row .callout-actions {
            flex: 0 0 auto;
            float: none;
            margin-left: auto;
          }
          .fms-sidebar .garage-sidebar-wrap {
            display: flex;
            flex-direction: column;
            height: 100%;
            overflow: hidden;
          }
          .fms-sidebar .garage-sidebar-list {
            flex: 1 1 auto;
            min-height: 0 !important;
            height: auto !important;
          }
          .fms-sidebar .garage-sidebar-list .ScrollbarsCustom {
            height: 100% !important;
          }
          .fms-sidebar .garage-load-more {
            text-align: center;
            padding: 8px 10px 12px;
          }
				`}
        <div className="fms-sidebar sidebar-bg-layer">
          {checkPrivileges("garage") && (
            <div className="garage-sidebar-wrap">
              <div
                className="section-head section-head-filter"
                style={{ paddingTop: 0, flexShrink: 0 }}
              >
                <ul className="filter-row" style={{ justifyContent: "end" }}>
                  <li style={{ paddingTop: 8, paddingBottom: 4 }}>
                    {checkPrivileges("garageCreate") && (
                      <Button
                        size="small"
                        onClick={(e) => this.props.openCreateFrom()}
                      >
                        {this.props.translate("sharedCreate")}
                      </Button>
                    )}
                  </li>
                </ul>
                <div>
                  <div style={{ width: "90%", marginLeft: "30px" }}>
                    <SearchField
                      label={this.props.translate("searchGarage")}
                      fullWidth
                      onChange={(e) => this.search(e, true, "searchText")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="search"
                              style={{ paddingLeft: 100 }}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <CityIcon />
                    <div style={{ width: "90%" }}>
                      <SearchField
                        label={this.props.translate("Search Garage City")}
                        fullWidth
                        onChange={(e) => this.search(e, true, "cityText")}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton aria-label="search">
                                <EnterIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <GarageIcon />
                    <div style={{ width: "90%" }}>
                      <SearchField
                        label={this.props.translate("Search Garage Type")}
                        fullWidth
                        onChange={(e) => this.search(e, true, "typeText")}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton aria-label="search">
                                <EnterIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <ul className="list-view with-padding-right geofence-sidebar-list garage-sidebar-list">
                <Scrollbar
                  disableTracksWidthCompensation={true}
                  scrollerProps={{
                    renderer: (props) => {
                      const { elementRef, ...restProps } = props;
                      return (
                        <div
                          {...restProps}
                          ref={elementRef}
                          id="scrollableDiv"
                        />
                      );
                    },
                  }}
                >
                  {this.props.itemPagination ? (
                    <InfiniteScroll
                      dataLength={visibleGarages.length}
                      next={this.props.fetchMoreItems}
                      hasMore={!!this.props.itemPagination.hasNext}
                      loader={<Loader defaultStyle={true} imgSize={50} />}
                      scrollableTarget="scrollableDiv"
                      endMessage={
                        this.props.itemPagination.hasNext
                          ? null
                          : this.props.endMessage
                      }
                    >
                      {commands1}
                      {this.props.itemPagination.hasNext ? (
                        <div className="garage-load-more">
                          <Button
                            size="small"
                            fullWidth
                            disabled={!!this.props.loadingMore}
                            onClick={this.props.fetchMoreItems}
                          >
                            {this.props.loadingMore
                              ? this.props.translate("sharedLoading")
                              : this.props.translate("loadMore")}
                          </Button>
                        </div>
                      ) : null}
                    </InfiniteScroll>
                  ) : null}
                </Scrollbar>
              </ul>
            </div>
          )}
        </div>
      </Style>
    );
  }
}

class ListRow1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onDeleteConfirmation: false,
    };
  }

  onDelete = () => {
    this.props.deleteItem(this.props.item.id);
    // if (this.props.item.id) {
    //   instance({
    //     url: `api/garages/${this.props.item.id}`,
    //     method: 'DELETE',
    //     headers: {
    //       Accept: 'application/json',
    //       'Content-Type': 'application/json'
    //     }
    //   })
    //   .then(response => {
    //       this.props.dispatch(removedGarages({ id: this.props.item.id }))
    //       this.props.dispatch(
    //         Notifications.success({
    //           message: this.props.translate('GaragesIsDeleted'),
    //           autoDismiss: 10
    //         })
    //       )
    //       // this.props.modeEmpty()
    //       this.setState({ item: {} })
    //       this.props.fetchGarages()
    //       this.props.closeForm()
    //   }).catch(error => {errorHandler(error, this.props.dispatch)})
    // }
  };

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state);
  }

  onRemovedItem = () => {
    this.setState({
      onDeleteConfirmation: true,
    });
  };
  onCancel = () => {
    this.setState({
      onDeleteConfirmation: false,
    });
  };

  shareMapsLink = async (e) => {
    e?.stopPropagation?.();
    const item = this.props.item || {};
    const mapsUrl = buildGarageMapsUrl(item);
    if (!mapsUrl) {
      this.props.dispatch(
        notifyError(
          this.props.translate("locationNotAvailable") ||
            "Location not available",
        ),
      );
      return;
    }

    const shareTitle = item.name || this.props.translate("workShops") || "Workshop";
    const shareText = item.address
      ? `${shareTitle}\n${item.address}`
      : shareTitle;

    try {
      if (navigator.share) {
        await navigator.share({
          title: shareTitle,
          text: shareText,
          url: mapsUrl,
        });
        return;
      }
    } catch (err) {
      // User cancelled share sheet — do nothing
      if (err?.name === "AbortError") return;
    }

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(mapsUrl);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = mapsUrl;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      this.props.dispatch(notifySuccess("Copied to clipboard!"));
    } catch (err) {
      window.open(mapsUrl, "_blank", "noopener,noreferrer");
    }
  };

  render() {
    const statusLabel = getGarageStatus(this.props.item);
    const chipStyle = getGarageStatusChipStyle(statusLabel);
    const canShare = !!buildGarageMapsUrl(this.props.item);

    return (
      <li
        // className={'list-row clearfix'}
        className={
          "clearfix list-row " +
          (parseInt(this.props.setGarageForm && this.props.setGarageForm.id) ===
            parseInt(this.props.item.id) && this.props?.showSingleGarage
            ? "active"
            : "")
        }
        key={this.props.item.id}
      >
        <label
          className="checkbox"
          onClick={(e) => {
            this.props.onOpenMap(this.props.item);
          }}
        >
          <div className="garage-row-content">
            <span
              className="unit-name garage-unit-name"
              style={{ fontSize: 12 }}
              title={this.props.item.name}
            >
              {this.props.item.name}
            </span>
            {statusLabel ? (
              <Tooltip title={statusLabel} arrow placement="top">
                <Chip
                  className="garage-status-chip"
                  label={statusLabel}
                  size="small"
                  sx={{
                    height: 20,
                    fontSize: 10,
                    fontWeight: 600,
                    backgroundColor: chipStyle.backgroundColor,
                    color: chipStyle.color,
                    "& .MuiChip-label": {
                      px: 0.75,
                      py: 0,
                    },
                  }}
                />
              </Tooltip>
            ) : null}
          </div>
        </label>
        <div className="callout-actions">
          <Tooltip
            title={
              this.props.translate("shareLocation") ||
              "Share Google Maps link"
            }
            arrow
            placement="top"
          >
            <span
              className="action"
              onClick={this.shareMapsLink}
              style={{
                opacity: canShare ? 1 : 0.4,
                cursor: canShare ? "pointer" : "not-allowed",
              }}
            >
              <ShareIcon className="material-icons" fontSize="small" />
            </span>
          </Tooltip>
          {checkPrivileges("garageUpdate") && (
            <span
              className="action"
              onClick={(e) => {
                this.props.editGarageForm(this.props.item);
              }}
            >
              <EditIcon className="material-icons" />
            </span>
          )}
          {checkPrivileges("garageDelete") && (
            <span className="action" onClick={this.onRemovedItem}>
              <DeleteIcon className="material-icons" />
            </span>
          )}
        </div>

        {this.state.onDeleteConfirmation && (
          <ConfirmDialoag
            onCancel={this.onCancel}
            onOk={this.onDelete}
            title={this.props.translate("areYouWantToDelete")}
            children={this.props.item.description}
          />
        )}
      </li>
    );
  }
}

const mapState = (state) => ({
  garages: state.garages,
  geoFence: state.geoFence,
  themecolors: state.themeColors,
});

const mapStateToProps = connect(mapState);
export const ListRow = mapStateToProps(withTranslationWrapper(ListRow1));
export default mapStateToProps(withTranslationWrapper(Garage));
